import Loading from '@/components/Loading'
import MainLayout from '@/layouts/MainLayout'
import React, { Suspense, useEffect } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router'

import {
  getMeGetConfigOptions,
  getMeOptions,
} from '@/client/@tanstack/react-query.gen'
import { useQueries, useQuery } from '@tanstack/react-query'
import dayjs from 'dayjs'
import { isInGame } from './lib/game'
import { useParamsOptions } from './models/Config'
import { useStore } from './store'

const Home = React.lazy(() => import('@/pages/Home'))

const App = () => {
  const { userLoaded: _userLoaded, updateState, loginSuccess } = useStore()
  const config = useQueries({
    queries: [useParamsOptions()],
    combine: (results) => {
      return {
        params: results?.[0]?.data,
      }
    },
  })

  const { status, error: _error } = useQuery({
    ...getMeOptions(),
    enabled: !!((isInGame() && loginSuccess) || !isInGame()),
  })

  const { status: statusConfig, error: _errorConfig } = useQuery({
    ...getMeGetConfigOptions(),
    enabled: !!((isInGame() && loginSuccess) || !isInGame()),
  })

  // const { data: _userState , status: statusState } = useQuery({
  //   ...getStateOptions(),
  //   enabled: !!userData?.id
  // })

  // useEffect(() => {
  //   if(statusState == 'success' || statusState == 'error') {
  //     updateState('stateLoaded', true)
  //   }
  // }, [statusState])

  useEffect(() => {
    if (status == 'success' || status == 'error') {
      updateState('userLoaded', true)
    }
  }, [status])

  useEffect(() => {
    if (statusConfig == 'success' || statusConfig == 'error') {
      updateState('userLoaded', true)
    }
  }, [statusConfig])

  useEffect(() => {
    if (config?.params) {
      updateState('loaded', true)
      updateState(
        'delta',
        Number(dayjs(config?.params?.current).unix()) * 1000 -
          new Date().getTime(),
      )
      updateState('errors', config?.params?.errors)
    }
  }, [config?.params])

  //Preload needed information
  //End preload needed information

  return (
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
        <MainLayout>
          <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route
              path="*"
              element={
                <>
                  <div className="text-center">Oops! Not found!</div>
                </>
              }
            ></Route>
          </Routes>
        </MainLayout>
      </Suspense>
    </BrowserRouter>
  )
}

export default App
